/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleHistoryManagementEditOrderResponse } from './CarpsaleHistoryManagementEditOrderResponse';

export type CarpsaleHistoryManagementEditOrderResponseApiRespoonse = {
    data?: CarpsaleHistoryManagementEditOrderResponse;
    status?: CarpsaleHistoryManagementEditOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleHistoryManagementEditOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

